"use client";

import React, { useState, useMemo } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  Chart as ChartJS,
  BarController,
  BarElement,
  LineController,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Chart } from "react-chartjs-2";

// Register chart.js components
ChartJS.register(
  BarController,
  LineController,
  BarElement,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend
);

const baseData = {
  labels: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", ],
  datasets: [
    {
      type: "line",
      label: "Stock Trend",
      data: [5000, 5500, 6000, 6000, 5800, 8000,],
      borderColor: "#FFBD26",
      borderWidth: 11,
      pointRadius: 0,
      fill: false,
      tension: 0,
      order: 0,
      yAxisID: "y",
    },
    {
      type: "bar",
      label: "Expenses",
      data: [6000, 7000, 7400, 7400, 8300, 8000],
      backgroundColor: Array(8).fill("#152C24"),
      borderRadius: { topLeft: 10, topRight: 10 },
      borderSkipped: false,
      order: 1,
      yAxisID: "y",
barPercentage:  0.99,         // reduce bar width a little (optional)
categoryPercentage: 0.9,    // increase to reduce group spacing

    },
    {
      type: "bar",
      label: "Revenue",
      data: [5000, 7000, 7800, 8200, 8700, 8000, ],
      backgroundColor: Array(8).fill("#2E453D"),
      borderRadius: { topLeft: 10, topRight: 10 },
      borderSkipped: false,
      order: 2,
      yAxisID: "y",
barPercentage: 0.9,         // reduce bar width a little (optional)
categoryPercentage: 0.9,    // increase to reduce group spacing

    },
  ],
};

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    tooltip: { mode: "index", intersect: false },
  },
  scales: {
    y: {
      min: 1000,
      max: 10000,
      grid: { display: false },
      position: "left",
      ticks: {
        stepSize: 1000,
        font: { size: 20, weight: "bold" },
            padding: 50, // ← Move numbers to the right (increase this)
        color: "#000",
        callback: (value) => (value === 0 ? "" : value),
      },
      offset: true,
    },
    yRight: {
      min: 1000,
      max: 10000,
      position: "right",
      grid: { drawOnChartArea: false },
      ticks: {
        stepSize: 1000,
        font: { size: 20, weight: "bold" },
        color: "#000",
        padding: 50, 
        callback: (value) => (value === 0 ? "" : value),
      },
      offset: true,
    },
    x: {
      grid: { display: false },
      ticks: {
        font: { size: 28, weight: "bold" },
        color: "#000",
        
      },
    },
  },
  layout: {
    padding: { top: 20, bottom: 40 },
  },
};

const dropdownItems = {
    COUNTRY: [
      "SOUTH AFRICA",
      "Botswana",
      "Cameroon",
      "Congo Democratic Republic (DRC)",
      "Cote-divorie",
      "Eswatini (Swaziland)",
      "Ethiopia",
      "Ghana",
      "Kenya",
      "Lesotho",
      "Malawi",
      "Mozambique",
      "Namibia",
      "Nigeria",
      "Rwanda",
      "Senegal",
      "Sierra Leone",
      "Somalia",
      "South Africa",
      "South Sudan",
      "Tanzania",
      "Uganda",
      "Zambia",
      "Zimbabwe",
    ],
    REGION: [
      "GAUTENG",
      "GAUTENG",
      "GAUTENG",
      "GAUTENG",
      "GAUTENG",
      "GAUTENG",
      "GAUTENG",
      "GAUTENG",
      "GAUTENG",
      "GAUTENG",
      "GAUTENG",
      "GAUTENG",
      "GAUTENG",
      "GAUTENG",
      "GAUTENG",
      "GAUTENG",
      "GAUTENG",
      "GAUTENG",
      "GAUTENG",
      "GAUTENG",
      "GAUTENG",
      "GAUTENG",
      "GAUTENG",
  
  
      "GAUTENG",
      "GAUTENG",
      "GAUTENG",
      "GAUTENG",
      "GAUTENG",
      "GAUTENG",
    ],
    PROJECT: [
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",    "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",    "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
      "ABBATOIR",
    ],
  
    CROP: [
      "MAIZE",
      "Apples",
      "Avocado",
      "Bananas",
      "Beans",
      "Cabbages",
      "Kale",
      "Mangoes",
      "Onions",
      "Passion Fruits",
      "Papaya",
      "Potatoes",
      "Strawberries",
      "Tomatoes",
      "Watermelon",
    ],
    LIVESTOCK: [
      "POULTRY",
      "POULTRY",
      "POULTRY",
      "POULTRY",
      "POULTRY",
      "POULTRY",
      "POULTRY",
      "POULTRY",
      "POULTRY",
      "POULTRY",
      "POULTRY",
      "POULTRY",
      "POULTRY",
      "POULTRY",
      "POULTRY",
      "POULTRY",
      "POULTRY",
      "POULTRY",
      "POULTRY",
      "POULTRY",
      "POULTRY",
      "POULTRY",
      "POULTRY",
      "POULTRY",
      "POULTRY",
      "POULTRY",
      "POULTRY",
      "POULTRY",
      "POULTRY",
      "POULTRY",
      "POULTRY",
      "POULTRY",
    ],
    REPORTS : [
      "PRODUCTION", "Revenue", "Inventory"],
  };
  
  const dropdownIcons = {
    COUNTRY:
      "https://res.cloudinary.com/dzngpgki4/image/upload/v1744492909/Pin_alt_ioedjs.png",
      REGION:
      "https://res.cloudinary.com/dzngpgki4/image/upload/v1744493134/Order_ytgysy.png",
      CROP:
         "https://res.cloudinary.com/dzngpgki4/image/upload/v1744493134/Order_ytgysy.png",
         DATA:
         "https://res.cloudinary.com/dzngpgki4/image/upload/v1744493134/Order_ytgysy.png",
      PROJECT:
      "https://res.cloudinary.com/dzngpgki4/image/upload/v1744493133/image_fdtjzb.png",
      LIVESTOCK:
      "https://res.cloudinary.com/dzngpgki4/image/upload/v1744493189/image_34_zwohkn.png",
  };
  
  const Dropdown = ({ label, items, type }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selected, setSelected] = useState(items[0]);
  
    const icon = dropdownIcons[type];
  
    return (
<div className="flex flex-col w-full relative ">
  {/* Label */}
  <label className="md:text-[24px] font-bold text-[6px] text-black mb-1 md:mb-1">
    {label}
  </label>

  {/* Button + Icon Container */}
  <div className="flex relative z-20 w-fit">
    {/* Dropdown Button */}
    <button
      onClick={() => setIsOpen((prev) => !prev)}
      className="xl:w-[160px] lg:w-[140px] md:w-[55px] w-[40px] h-[15px] md:h-[46px] bg-[#2E453D] text-white font-bold flex justify-between items-center px-1 rounded-l-[10px]"
    >
      <span className="md:text-[14px] md:px-4 text-[4px] md:mt-0 mt-[2px]">{selected}</span>
    </button>

    {/* Icon Box */}
    <div
      className="w-[20px] h-[15px] md:h-[46px] md:w-[40px] bg-[#152C24] text-white flex justify-center items-center rounded-tr-[10px]   rounded-br-[10px]  -ml-2 z-30 cursor-pointer"
      onClick={() => setIsOpen((prev) => !prev)}
    >
      <img
        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
        alt="expand"
        className="w-3 h-3 md:w-5 md:h-5"
      />
    </div>
  </div>

  {/* Dropdown List */}
  {/* Dropdown List */}
  <AnimatePresence>
    {isOpen && (
      <motion.ul
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        className="absolute top-full mt-1 left-0 z-50 md:w-[180px] w-[100px] bg-white/90 rounded-lg shadow-lg"
      >
        {items.map((item, index) => (
          <li
            key={index}
            onClick={() => {
              setSelected(item);
              setIsOpen(false);
            }}
            className="md:p-3 p-1 bg-[#CFD7D7] md:mt-1 md:text-[18px] text-[10px] rounded-md hover:bg-[#afafaf] cursor-pointer flex items-center"
          >
            <img src={icon} className="md:w-4 md:h-4 h-2 w-2 mr-2" alt="icon" />
            <span className="text-black">{item}</span>
          </li>
        ))}
      </motion.ul>
    )}
  </AnimatePresence>

  {/* Hint Text */}
  <p className="md:text-[14px] text-[6px] font-normal mt-1 text-black">
    Select {label}
  </p>

</div>
  
    
    );
  };
const ChartComponent = () => {
  const [hoveredColor, setHoveredColor] = useState(null);

  const filteredData = useMemo(() => {
    return {
      ...baseData,
      datasets: baseData.datasets.map((dataset) => {
        if (dataset.type === "line") return dataset;

        return {
          ...dataset,
          backgroundColor: dataset.backgroundColor.map((color) =>
            !hoveredColor || color === hoveredColor
              ? color
              : "rgba(0,0,0,0.05)"
          ),
        };
      }),
    };
  }, [hoveredColor]);

  return (
   <div>
    <div  className="md:px-24  w-[90%]">
    <div className="flex  items-center md:mb-5 mb-3">
        <h2 className="text-[14px] md:text-[36px] font-bold text-[#FDBD26] ">
        IMPACT
          </h2>
          
        </div>
      <div className="flex md:gap-2 gap-[1px]    ">
    

        {Object.keys(dropdownItems).map((type) => {
          const customLabels = {
            Crop: "Crop Report",
            Livestock: "Livestock Report",
            Type: "Type of Report",
          };

          const displayLabel = customLabels[type] || type;

          return (
            <div key={type} className="w-full ">
              <Dropdown label={displayLabel} items={dropdownItems[type]} type={type} />
            </div>
          );
        })}
      </div>
      <h2 className="text-[14px] md:text-[36px] md:mt-10 font-bold text-[#FDBD26] ">
      MAIZE
          </h2>
    </div>
     <div className="relative md:-mt-[60px]  w-[98%]  md:px-11 h-[600px] mb-32 ">
 
     <div className="w-full h-[600px] relative z-10">
  <Chart type="bar" data={filteredData} options={options} />
</div>


 {/* Color filter boxes */}
 <div className="absolute bottom-[-50px] right-0 w-[85%] grid grid-cols-3 gap-4 ">
   {/* Expenses */}
   
   <div className="flex flex-col gap-2">

     <div className="flex items-center space-x-3">
       <div
         className="w-[42px] h-[42px] bg-[#FFBD26] cursor-pointer"
         onMouseEnter={() => setHoveredColor("#FFBD26")}
         onMouseLeave={() => setHoveredColor(null)}
         title="Highlighted Expense"
       />
       <h1 className="text-[24px] font-bold text-[#152C24]">Number of Farmers</h1>
     </div>
   </div>

   {/* Revenue */}
   <div className="flex flex-col gap-2">
   
     <div className="flex items-center space-x-3">
       <div
         className="w-[42px] h-[42px] bg-[#2E453D] cursor-pointer"
         onMouseEnter={() => setHoveredColor("#2E453D")}
         onMouseLeave={() => setHoveredColor(null)}
         title="Highlighted Revenue"
       />
       <h1 className="text-[24px] font-bold text-[#2E453D]">Production </h1>
     </div>
   </div>
   <div className="flex flex-col gap-2">

     <div className="flex items-center space-x-3">
       <div
         className="w-[42px] h-[42px] bg-[#152C24] cursor-pointer"
         onMouseEnter={() => setHoveredColor("#152C24")}
         onMouseLeave={() => setHoveredColor(null)}
         title="Highlighted Expense"
       />
       <h1 className="text-[24px] font-bold text-[#152C24]">Inventory</h1>
     </div>
   </div>
 </div>
</div>
   </div>
  );
};

export default ChartComponent;
